import styled from 'styled-components';

export const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./components/layout/PhoneNumbersPage.js